export default [{
  _name: 'CSidebarNav',
  _children: [
    {
      _name: 'CSidebarNavDropdown',
      name: 'Tableaux de bord',
      route: '/dashboard',
      icon: 'cil-speedometer',
      items: [{
          name: 'Résultat de l\'institut',
          to: '/dashboard/institute-results'
        },
        {
          name: 'Soldes disponibles',
          to: '/dashboard/remaining-budgets',
        }
      ]
    },
    {
      _name: 'CSidebarNavDropdown',
      name: 'Projets',
      route: '/projects',
      icon: 'cil-list-rich',
      items: [{
          name: 'Vue AGP',
          to: '/projects/agp-data'
        },
        {
          name: 'Vue comptable',
          to: '/projects/accounting-data'
        },
        {
          name: 'Mandats',
          to: '/projects/mandate-data'
        },
        {
          name: 'Autofinancement',
          to: '/projects/autofunding'
        },
        {
          name: 'Provisions de risque',
          to: '/projects/lossprovisions'
        },
        {
          name: 'Frais de gestion',
          to: '/projects/fees'
        },
      ]
    },
    {
      _name: 'CSidebarNavDropdown',
      name: 'Collaborateurs',
      route: '/staff',
      icon: 'cil-people',
      items: [
        {
          name: 'Salaires fonds de tiers',
          to: '/staff/salaries-fdt'
        },
        {
          name: 'Taux d\'affectation',
          to: '/staff/assigned-rates'
        },
        //{
        //  name: 'Taux horaires',
        //  to: '/staff/hourly-rates'
        //}
      ]
    },
    {
      _name: 'CSidebarNavDropdown',
      name: 'Anomalies',
      route: '/anomalies',
      icon: 'cil-warning',
      items: [
        {
          name: 'Dépassements P5',
          to: '/anomalies/overruns-p5',
          badge: { color: 'danger', text: 'Anomalie' }
        },
        {
          name: 'Initiales inconnues',
          to: '/anomalies/missing-initials',
          badge: { color: 'danger', text: 'Anomalie' }
        },
      ]
    },
    { _name: 'CSidebarNavDivider' }, 
    { _name: 'CSidebarNavDivider' },
    { _name: 'CSidebarNavDivider' },
    { _name: 'CSidebarNavDivider' },
    { _name: 'CSidebarNavDivider' },
    {
      _name: 'CSidebarNavItem',
      name: 'Déconnexion',
      to: '/login',
      icon: {
        name: 'cil-power-standby',
        class: 'text-danger'
      }
    }
  ]
}]
